import { render } from "./PostCard.vue?vue&type=template&id=5fe4cc2c&ts=true"
import script from "./PostCard.vue?vue&type=script&lang=ts"
export * from "./PostCard.vue?vue&type=script&lang=ts"

import "./PostCard.vue?vue&type=style&index=0&id=5fe4cc2c&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__